// ./stores/memos.js
import {create} from 'zustand'

export interface Note {
    content: string,
    content1: string|null,
    content2: string|null,
    content3: string|null,
    title: string|null,
    createdAt: string,
    estID: number,
    hospitalName: string,
    reservedAt: string,
    userID: number,
    noteID: number,
    diagnosisAt: string|null
}

interface NoteState {
  noteList : Note[],
  setNoteList : (noteList:Note[]) => void
}

const useNoteStore = create<NoteState>((set) => ({
  noteList: [],
  setNoteList: (noteList:Note[]) => set({ noteList: noteList })
}))

export default useNoteStore